import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import { Stepper } from "./../../themes/userq/Stepper/Stepper";
import { Button } from "./../../themes/userq/Button/Button";
import { LoadingIcon } from "./../../themes/userq/Loader/loadingIcon";
import { Accordian } from "./../../themes/userq/Accordion/Accordion";
import { Icon } from "./../../themes/userq/Icon/Icon";
import Header from "./components/header";

import { useState, useEffect, useRef } from "react";
import {
	getTestData,
	deletePrototypeTestTaskService,
	updatePrototypeTestService,
	addPrototypeTestTaskService,
	updateTestSettingsService,
} from "../../../services/test";
import toast from "react-hot-toast";
import ConfirmationModal from "../../themes/userq/Modal/ConfirmationModal";
import moment from "moment";
import { ToastMessage } from "../../themes/userq/ToastMessage/ToastMessage";
import { Text } from "../../themes/userq/Text/Text";
import { ToggleButton } from "../../themes/userq/ToggleButton/ToggleButton";
import { ConclusionQuestions } from "./conclusion_questions";
import { IntroductionQuestions } from "./introduction_questions";
import { settings } from "../../../data/settings";
import { RadioButton } from "../../themes/userq/RadioButton/RadioButton";
import Task from "./prototype_test/task";
import ChangeOrderModal from "./prototype_test/change_order";
import HelpModal from "../../themes/userq/Modal/HelpModal";
import { GuideLink } from "../../themes/userq/GuideLink/GuideLink";
import { Helmet } from "react-helmet";
import { useTestBuilderData } from "./contexts/TestBuilderContext.js";
import { Tag } from "../../themes/userq/Tag/Tag.js";

const SCREEN_RECORDING_DESKTOP_CHROME_COPY = "This will be restricted to only Desktop users using the Chrome browser.";

export default function PrototypeTest() {
	let { test_id } = useParams();
	const nodeRef = useRef(null);
	const navigate = useNavigate();

	ReactSession.setStoreType("localStorage");

	const { updateTestLength, getTestLength, allowEditAccess } =
		useTestBuilderData();

	const [formValues, setFormValues] = useState({
		objective: "closed",
		resync_confirmation: 0,
		is_screen_recording_enabled: 0,
		tasks: [],
	});
	const [overrideErrors, setOverrideErrors] = useState(false);
	const [validate_form, setValidateForm] = useState(false);
	const [changeOrderModal, setChangeOrderModal] = useState({ open: false });
	const [testSettingModal, setTestSettingModal] = useState({ open: false });
	const [screenRecordingEnableModalOpen, setScreenRecordingEnableModalOpen] =
		useState(false);
	const [screenRecordingProceedLoading, setScreenRecordingProceedLoading] =
		useState(false);
	const [screenRecordingToggleMountKey, setScreenRecordingToggleMountKey] =
		useState(0);
	const [pageLoading, setPageLoading] = useState(false);
	const [isSaved, setIsSaved] = useState({ status: "", message: "" });
	const [prototypeTestStepLoading, setPrototypeTestStepLoading] =
		useState(false);
	const [lastSaved, setLastSaved] = useState(null);
	const [isLoading, setLoading] = useState(false);
	const [confirmModal, setConfirmModal] = useState({ open: false });
	const [switchConfirmModal, setSwitchConfirmModal] = useState({
		open: false,
	});
	const [helpModal, setHelpModal] = useState({ open: false });
	const [test, setTest] = useState("");
	const [publishing_credits, setPublishingCredits] = useState(0);

	const [searchParams] = useSearchParams();

	const [accordians, setAccordians] = useState({
		introduction: false,
		prototypetest: searchParams.get("error") == "true" ? true : false,
		conclusion: false,
	});

	const [formErrors, setFormErrors] = useState({
		title: null,
		tasks: {},
		error_class: "input_error",
	});

	const [stepperError, setStepperError] = useState(false);
	const [introCount, setIntroCount] = useState(0);
	const [concCount, setConcCount] = useState(0);
	const [introductionQuestions, setIntroductionQuestions] = useState(null);
	const [conclusionQuestions, setConclusionQuestions] = useState(null);

	const [language, setLanguage] = useState("en");

	const [addTaskLoading, setAddTaskLoading] = useState(false);

	const [show_support_panel, setShowSupportPanel] = useState(false);

	const taskRefs = useRef({});

	const introductionRef = useRef(null);

	const conclusionRef = useRef(null);

	const [copyPrototypeLink, setCopyPrototypeLink] = useState(null);

	const isScreenRecordingUnavailable = test?.device === "mobile";

	useEffect(() => {
		if (validate_form) {
			setValidateForm(false);

			if (searchParams.get("error") == "true") {
				setStepperError(true);

				validateFullForm();
			}
		}
	}, [validate_form]);

	const showError = (error) => {
		toast(
			<ToastMessage
				type={"error"}
				message={error}
				closable={false}
				onClose={() => {
					toast.dismiss();
				}}
			/>,
			{
				id: "error",
				className: "errortoast",
				position: "bottom-center",
				duration: settings.toast_duration,
			}
		);
	};

	const addPrototypeTestTask = () => {
		let token = ReactSession.get("token");

		setAddTaskLoading(true);

		addPrototypeTestTaskService({ test_id: test_id }, token).then(
			(response) => {
				setAddTaskLoading(false);

				if (response.success) {
					getTestLength(test_id);
					var tasksLoc = Object.assign([], formValues.tasks);

					tasksLoc.push(response.task);

					setFormValues({ ...formValues, tasks: tasksLoc });

					var copy_prototype_link = null;
					var prototype_link = null;

					tasksLoc.forEach(function (task) {
						if (!prototype_link) {
							prototype_link = task.prototype_link;
							copy_prototype_link = task.prototype_link;
						} else if (
							task.prototype_link &&
							prototype_link !== task.prototype_link
						) {
							copy_prototype_link = null;
						}
					});
					setCopyPrototypeLink(copy_prototype_link);
				} else {
					showError(response.message);
				}
			}
		);
	};

	const getTestApi = () => {
		let token = ReactSession.get("token");

		setPageLoading(true);
		setLoading(true);

		getTestData({ test_id: test_id }, token).then((response) => {
			setPageLoading(false);
			setLoading(false);

			if (response.success) {
				if (response.test.workspace_project) {
					if (response.workspace_project_team_member) {
						if (response.workspace_project_team_member.status != "active") {
							navigate(
								"/wsp/" +
								response.test.workspace_project.workspace_id +
								"/p/" +
								response.test.workspace_project.id
							);
						}
					}
				}
				allowEditAccess({
					test_id: test_id,
					workspace_id: response.test.workspace_id,
					workspace_project_id: response.test.workspace_project_id,
				});

				getTestLength(test_id);
				setTest(response.test);

				setIntroCount(response.test.briefingQuestion.length);
				setConcCount(response.test.debriefingQuestion.length);
				setIntroductionQuestions(response.test.briefingQuestion);
				setConclusionQuestions(response.test.debriefingQuestion);

				let questions = [];

				response.test.preferenceTestQuestion.forEach((question) => {
					questions.push(JSON.parse(question));
				});

				if (response.test.status) {
					if (response.test.status == "published") {
						navigate("/r/project/" + response.test.project_id);
					} else {
						if (
							response.test.welcome_title == "" ||
							response.test.welcome_description == ""
						) {
							localStorage.setItem(
								"stepper_error",
								"The welcome page cannot be empty! Please enter a title and a description."
							);
							navigate("/r/test/" + test_id + "/welcome?error=true");
							showError(
								"The welcome page cannot be empty! Please enter a title and a description."
							);
						}
					}
				}

				setLastSaved(moment(response.test.updated_at));

				setFormValues({
					...formValues,
					is_screen_recording_enabled:
						response.test.is_screen_recording_enabled,
					objective: response.test.prototype_test_setting
						? response.test.prototype_test_setting.objective
						: "closed",
					resync_confirmation: response.test.prototype_test_setting
						? response.test.prototype_test_setting.resync_confirmation
						: 0,
					tasks:
						response.test.prototype_test_tasks.length > 0
							? response.test.prototype_test_tasks
							: [{ is_synced: false, prototype_link: "" }],
				});
				setValidateForm(true);
			} else {
				if (response.message == "Project not found.") {
					navigate("/404");
				} else {
					showError(response.message);
				}
			}
		});
	};

	const validateFullForm = () => {
		var error = false;
		var question_error = false;
		var firsterrorid = null;

		var form_errors = resetFormErrors()
			? resetFormErrors()
			: {
				tasks: {
					goal_screen: null,
					description: null,
					prototype_link: null,
				},
			};

		setOverrideErrors(true);

		if (conclusionRef.current) {
			conclusionRef.current.resetErrors();
		}
		if (introductionRef.current) {
			introductionRef.current.resetErrors();
		}
		for (var i = 0; i < formValues.tasks.length; i++) {
			var task = formValues.tasks[i];

			if (taskRefs.current[task.id]) {
				var task_ref = taskRefs.current[task.id];

				if (task_ref.followupRef) {
					var followup_ref = task_ref.followupRef;

					if (followup_ref.questionRef) {
						followup_ref.questionRef.resetErrors();
					}
					if (followup_ref.editQuestionRef) {
						followup_ref.editQuestionRef.resetErrors();
					}
				}
			}
		}

		var reg =
			/^(?:https:\/\/)?(?:www\.)?figma\.com\/(proto)\/([0-9a-zA-Z]{22,128})(?:\/?([^\?]+)?(.*))?$/;

		if (introductionRef.current) {
			error = !introductionRef.current.questionValidateForm();

			question_error = error;
		}

		if (!error) {
			for (var i = 0; i < formValues.tasks.length; i++) {
				var task = formValues.tasks[i];
				form_errors["tasks"][task.id] = {};
				var task_errors = {};

				if (!task.prototype_link) {
					task_errors = {
						...task_errors,
						prototype_link: "A figma prototype link is required",
					};

					if (firsterrorid == null) {
						firsterrorid = "prototype_link_" + task.id;
					}

					error = true;
				} else if (!reg.test(task.prototype_link)) {
					task_errors = {
						...task_errors,
						prototype_link:
							"We couldn’t recognise that Figma link, please check it and try again",
					};

					if (firsterrorid == null) {
						firsterrorid = "prototype_link_" + task.id;
					}

					error = true;
				} else if (!task.is_synced) {
					task_errors = {
						...task_errors,
						prototype_link: "Prototype link is not synced",
					};

					if (firsterrorid == null) {
						firsterrorid = "prototype_link_sync_" + task.id;
					}

					error = true;
				} else if (!task.description) {
					if (formValues.objective == "closed") {
						task_errors = {
							...task_errors,
							description: "A task description is required",
						};
					} else {
						task_errors = {
							...task_errors,
							description: "An instruction is required",
						};
					}
					if (firsterrorid == null) {
						firsterrorid = "task_description_" + task.id;
					}
					error = true;
				} else if (
					formValues.objective == "closed" &&
					!task.goal_screen_node_id
				) {
					task_errors = {
						...task_errors,
						goal_screen: "A goal screen is required",
					};

					if (firsterrorid == null) {
						firsterrorid = "goal_screen_" + task.id;
					}

					error = true;
				} else {
					if (taskRefs.current[task.id]) {
						var task_ref = taskRefs.current[task.id];

						if (task_ref.followupRef) {
							var followup_ref = task_ref.followupRef;

							if (followup_ref.questionRef) {
								question_error =
									followup_ref.questionRef.handleQuestionSubmit(true);
							}
							if (followup_ref.editQuestionRef) {
								question_error =
									followup_ref.editQuestionRef.handleQuestionSubmit(true);
							}
						}
					}
				}
				if (!question_error) {
					if (formValues.objective == "open" && task.questions.length == 0) {
						task_errors = {
							...task_errors,
							questions: "At least one question is required",
						};

						if (firsterrorid == null) {
							firsterrorid = "questions_" + task.id;
						}
						error = true;
					} else if (
						formValues.objective == "open" &&
						task.questions.length > 0
					) {
						var no_of_optional = 0;

						task.questions.forEach(function (item) {
							if (item.is_optional) {
								no_of_optional++;
							}
						});
						if (no_of_optional == task.questions.length) {
							if (firsterrorid == null) {
								firsterrorid = "questions_" + task.id;

								showError("At least one question has to be mandatory");
							}
							error = true;
						}
					}
				}

				form_errors["tasks"][task.id] = task_errors;

				if (error || question_error) {
					break;
				}
			}
		}
		if (!error && !question_error && conclusionRef.current) {
			error = !conclusionRef.current.questionValidateForm();

			question_error = error;
		}
		if (
			error &&
			!question_error &&
			firsterrorid != null &&
			accordians["prototypetest"]
		) {
			document.getElementById(firsterrorid).scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
		}

		if (error && !question_error) {
			setStepperError(true);
			localStorage.setItem(
				"stepper_error",
				"You missed some key information. Please check again and fill out any missing fields."
			);
			showError(
				"You missed some key information. Please check again and fill out any missing fields."
			);

			setFormErrors(form_errors);
		}

		return error || question_error;
	};

	const saveBuildTestStep = () => {
		var error = validateFullForm();

		if (!error) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "create_test_step2",
				type: test.methodology,
				userID: ReactSession.get("user")
					? ReactSession.get("user").user_id
					: "",
			});

			navigate("/r/test/" + test_id + "/thank-you");
		} else {
			return false;
		}
	};

	const savePrototypeTestData = (form, shouldnavigate) => {
		if (shouldnavigate) {
			setPrototypeTestStepLoading(true);
		}
		setIsSaved({ status: "loading", message: "" });

		let data = Object.assign({}, form);
		data["test_id"] = test_id;
		data["autosave"] = 1;

		if (shouldnavigate) {
			data["autosave"] = 0;
		}

		return updatePrototypeTestService(data, ReactSession.get("token"))
			.then((response) => {
				setLoading(false);
				setPrototypeTestStepLoading(false);

				if (response && response.success) {
					getTestLength(test_id);
					setFormValues({
						...form,
						is_screen_recording_enabled:
							response.test.is_screen_recording_enabled,
						objective: response.test.prototype_test_setting
							? response.test.prototype_test_setting.objective
							: "closed",
						resync_confirmation: response.test.prototype_test_setting
							? response.test.prototype_test_setting.resync_confirmation
							: 0,
						tasks:
							response.test.prototype_test_tasks.length > 0
								? response.test.prototype_test_tasks
								: [{ is_synced: false, prototype_link: "" }],
					});

					setIsSaved({ status: "success", message: "" });
					setLastSaved(moment.now());
					if (shouldnavigate) {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							event: "create_test_step2",
							type: test.methodology,
							userID: ReactSession.get("user")
								? ReactSession.get("user").user_id
								: "",
						});
						navigate("/r/test/" + test_id + "/thank-you");
					}
					return { success: true };
				}
				setIsSaved({ status: "error", message: response.message });
				showError(response.message);
				return { success: false };
			})
			.catch(() => {
				setLoading(false);
				setPrototypeTestStepLoading(false);
				setIsSaved({ status: "error", message: "" });
				return { success: false };
			});
	};

	useEffect(() => {
		getTestApi();
		if (searchParams.get("error") == "true") {
			setStepperError(true);
		}
	}, []);

	useEffect(() => {
		if (nodeRef.current) {
			nodeRef.current.focus();
		}
	}, []);

	const resetFormErrors = () => {
		let formErrorsLocal = Object.assign({}, formErrors);
		for (var key in formErrors) {
			if (key == "tasks") {
				formErrorsLocal[key] = {};
			} else {
				formErrorsLocal[key] = null;
			}
		}
		setFormErrors(formErrorsLocal);
	};

	const deleteTask = (task_id) => {
		let token = ReactSession.get("token");

		setLoading(true);
		deletePrototypeTestTaskService(
			{ id: task_id, test_id: test_id },
			token
		).then((response) => {
			setLoading(false);
			if (response.success) {
				getTestLength(test_id);
				setLastSaved(moment());

				var tasks = [];
				formValues.tasks.forEach(function (item, index) {
					if (item.id != task_id) {
						var new_task = item;
						tasks.push(new_task);
					}
				});

				setFormValues({ ...formValues, tasks: tasks });

				var copy_prototype_link = null;

				var prototype_link = null;

				tasks.forEach(function (task) {
					if (!prototype_link) {
						prototype_link = task.prototype_link;
						copy_prototype_link = task.prototype_link;
					} else if (
						task.prototype_link &&
						prototype_link !== task.prototype_link
					) {
						copy_prototype_link = null;
					}
				});
				setCopyPrototypeLink(copy_prototype_link);
			} else {
				showError(response.message);
			}
		});
	};

	const [deviceSettingLoading, setDeviceSettingLoading] = useState(false);

	const updateTestDevice = (device, opts = {}) => {
		const token = ReactSession.get("token");
		const formSnapshot =
			opts.formSnapshot !== undefined ? opts.formSnapshot : formValues;

		if (!test || !test.id) {
			return Promise.resolve({ success: false });
		}

		var data = new FormData();

		data.append("test_name", test.test_name);
		data.append("methodology", test.methodology);
		data.append("device", device);
		data.append("language", test.language);
		data.append("workspace_id", test.workspace_id);
		data.append("project_id", test.project_id);
		data.append("test_id", test.id);

		setDeviceSettingLoading(true);

		return updateTestSettingsService(data, token)
			.then((response) => {
				if (!response || !response.success) {
					setDeviceSettingLoading(false);
					if (response && response.message) {
						showError(response.message);
					}
					return { success: false };
				}

				var testLocal = { ...test };
				testLocal.device = device;

				setTest(testLocal);
				setDeviceSettingLoading(false);

				if (device === "mobile") {
					setTestSettingModal((m) => ({
						...m,
						open: false,
					}));
					const hadRecording = formSnapshot.is_screen_recording_enabled == 1;
					return savePrototypeTestData(
						{
							...formSnapshot,
							is_screen_recording_enabled: 0,
						},
						false
					).then((saveRes) => {
						// if (hadRecording && saveRes?.success) {
						// 	showScreenRecordingDesktopChromeInfo();
						// }
						return { success: true, saveRes };
					});
				}

				if (device === "all" && formSnapshot.is_screen_recording_enabled == 1) {
					return savePrototypeTestData(
						{
							...formSnapshot,
							is_screen_recording_enabled: 0,
						},
						false
					).then((saveRes) => {
						// if (saveRes?.success) {
						// 	showScreenRecordingDesktopChromeInfo();
						// }
						return { success: true, saveRes };
					});
				}

				return { success: true };
			})
			.catch((err) => {
				setDeviceSettingLoading(false);
				if (typeof err === "string") {
					showError(err);
				}
				return { success: false };
			});
	};

	const confirmEnableScreenRecording = () => {
		const snapshot = formValues;

		const saveRecordingOn = () => {
			return savePrototypeTestData(
				{ ...snapshot, is_screen_recording_enabled: 1 },
				false
			);
		};

		const finish = () => {
			setScreenRecordingProceedLoading(false);
		};

		setScreenRecordingProceedLoading(true);

		if (test.device === "desktop") {
			saveRecordingOn()
				.then((saveRes) => {
					if (saveRes?.success !== false) {
						setScreenRecordingEnableModalOpen(false);
					}
				})
				.finally(finish);
			return;
		}

		updateTestDevice("desktop", { formSnapshot: snapshot })
			.then((res) => {
				if (!res?.success) {
					return;
				}
				return saveRecordingOn().then((saveRes) => {
					if (saveRes?.success !== false) {
						setScreenRecordingEnableModalOpen(false);
					}
				});
			})
			.finally(finish);
	};

	const renderTasks = () => {
		return formValues.tasks.map(function (task, index) {
			return (
				<Task
					ref={(element) => {
						taskRefs.current[task.id] = element;
					}}
					opentestSettingModal={() => {
						setTestSettingModal({
							...testSettingModal,
							open: true,
						});
					}}
					language={test.language}
					openHelpModal={() => {
						setHelpModal({ ...helpModal, open: true });
					}}
					changeOrder={() => {
						setChangeOrderModal({
							...changeOrderModal,
							open: true,
						});
					}}
					overrideErrors={overrideErrors}
					taskErrors={
						formErrors["tasks"][task.id] ? formErrors["tasks"][task.id] : {}
					}
					total_tasks={formValues.tasks.length}
					key={"proto-type-task-" + index}
					setConfirmModal={setConfirmModal}
					test={test}
					setIsSaved={setIsSaved}
					test_id={test_id}
					dont_ask_again={formValues.resync_confirmation == 0 ? false : true}
					objective={formValues.objective}
					task={task}
					index={index}
					updateTask={(task, index) => {
						setOverrideErrors(false);

						var tasksLoc = Object.assign([], formValues.tasks);

						tasksLoc[index] = task;

						setFormValues({ ...formValues, tasks: tasksLoc });

						var copy_prototype_link = null;

						var prototype_link = null;

						tasksLoc.forEach(function (task) {
							if (!prototype_link) {
								prototype_link = task.prototype_link;
								copy_prototype_link = task.prototype_link;
							} else if (
								task.prototype_link &&
								prototype_link !== task.prototype_link
							) {
								copy_prototype_link = null;
							}
						});

						setCopyPrototypeLink(copy_prototype_link);
					}}
					updateTaskAndDontAsk={(task, index) => {
						var tasksLoc = Object.assign([], formValues.tasks);

						tasksLoc[index] = task;

						setFormValues({
							...formValues,
							tasks: tasksLoc,
							resync_confirmation: 1,
						});
					}}
					setStepperError={setStepperError}
					copyPrototypeLink={copyPrototypeLink}
				/>
			);
		});
	};

	const checkValidBtnState = () => {
		var error = false;

		for (var i = 0; i < formValues.tasks.length; i++) {
			var task = formValues.tasks[i];

			if (!task.prototype_link) {
				error = true;
				break;
			} else if (!task.is_synced) {
				error = true;
				break;
			} else if (!task.description) {
				error = true;
				break;
			} else if (
				formValues.objective == "closed" &&
				!task.goal_screen_node_id
			) {
				error = true;
				break;
			} else if (formValues.objective == "open" && task.questions.length == 0) {
				error = true;
				break;
			} else if (formValues.objective == "open" && task.questions.length > 0) {
				var no_of_optional = 0;

				task.questions.forEach(function (item) {
					if (item.is_optional) {
						no_of_optional++;
					}
				});
				if (no_of_optional == task.questions.length) {
					error = true;
					break;
				}
			}
		}

		return error;
	};

	const checkIfAddBtn = () => {
		let canBeAdded = true;

		for (var i = 0; i < formValues.tasks.length; i++) {
			if (!formValues.tasks[i].is_synced) {
				canBeAdded = false;
				break;
			}
		}

		return canBeAdded;
	};

	return (
		<LayoutResearcher
			isLoading={false}
			fixed_header_target={true}
			wrapClass={`create-test-data-wrapper ${test && test.language == "ar" ? "arabic_wrapper_main" : ""
				}`}
			skipCheck={false}
			extendedFooter={false}
			activeMenu={""}
			openSupportPanel={show_support_panel}
			hideSupportPanel={() => {
				setShowSupportPanel(false);
			}}
		>
			<Helmet>
				<title>Create prototype test - step 2 | UserQ</title>
			</Helmet>
			<div className="three-column-layout">
				<Header
					test={test}
					isLoading={isLoading}
					isSaved={isSaved}
					credits_required={publishing_credits}
				/>
				<div className="three-column-layout-body">
					<div className="three-column-layout-left">
						<Stepper
							test={test}
							completed_step={1}
							stepCallback={() => { }}
							error={stepperError}
						/>
					</div>
					{pageLoading && (
						<div className="test-section-loader">
							<LoadingIcon />
						</div>
					)}
					{!pageLoading && (
						<>
							<div className="three-column-layout-center">
								<div className="create-prefer-text-wrapper create-prototype-test">
									<div className="card-sorting-creating-test-wrap">
										<div className="section-minimum-height">
											<Accordian
												title={"Introduction questions"}
												subtitle={"(Optional)"}
												tooltip={"Some cool text"}
												open={accordians["introduction"] ? true : false}
												onChange={() => {
													let new_accordians = Object.assign({}, accordians);

													for (var key in accordians) {
														if (key == "introduction") {
															if (accordians[key]) {
																new_accordians[key] = false;
															} else {
																new_accordians[key] = true;
															}
														}
													}
													setAccordians(new_accordians);
												}}
												questionCount={introCount}
											>
												<IntroductionQuestions
													ref={introductionRef}
													questions={introductionQuestions}
													test={test}
													setLoading={(status) => setIsSaved(status)}
													changeCount={(newCount) => {
														setIntroCount(newCount);
													}}
													updateQuestions={(questions) => {
														setIntroductionQuestions([...questions]);
													}}
												/>
											</Accordian>
											<Accordian
												title={"Prototype test"}
												tooltip={"Some cool text"}
												open={accordians["prototypetest"] ? true : false}
												onChange={() => {
													let new_accordians = Object.assign({}, accordians);

													for (var key in accordians) {
														if (key == "prototypetest") {
															if (accordians[key]) {
																new_accordians[key] = false;
															} else {
																new_accordians[key] = true;
															}
														}
													}
													setAccordians(new_accordians);
												}}
											>
												<div className="card-sorting-test-wrap prefer-design-wrap">
													<div className="cardsorting-wrap-top">
														<Text
															type={"body-text-1"}
															fontWeight={"medium-font"}
															cssClasses="text-black"
														>
															Choose the objective of the prototype test
														</Text>
														<Text
															type={"body-text-3"}
															fontWeight={"medium-font"}
														>
															Choose between a specific task and free flow type
														</Text>
													</div>
													<div
														className={`cardsorting-wrap-mid-data`}
														id="title"
													>
														<RadioButton
															value={"closed"}
															isChecked={
																formValues.objective == "closed" ? true : false
															}
															onChange={() => {
																var error = false;

																var form_errors = {
																	...formErrors,
																};
																form_errors = {
																	...form_errors,
																	tasks: {},
																};

																for (
																	var i = 0;
																	i < formValues.tasks.length;
																	i++
																) {
																	var task = formValues.tasks[i];

																	if (task.questions.length > 0) {
																		error = true;
																		break;
																	}
																	if (task.description) {
																		error = true;
																		break;
																	}
																}
																setFormErrors(form_errors);

																if (error) {
																	setSwitchConfirmModal({
																		...switchConfirmModal,
																		open: true,
																		objective: "closed",
																	});
																} else {
																	setFormValues({
																		...formValues,
																		objective: "closed",
																	});
																	savePrototypeTestData(
																		{
																			...formValues,
																			objective: "closed",
																		},
																		false
																	);
																}
															}}
															label="I want users to complete a specific task"
															sublabel="Ask participants to perform a task and reach a defined end screen"
														/>
														<div className="mt-32">
															<RadioButton
																value={"open"}
																onChange={() => {
																	var form_errors = {
																		...formErrors,
																	};

																	form_errors = {
																		...form_errors,
																		tasks: {},
																	};

																	var error = false;

																	for (
																		var i = 0;
																		i < formValues.tasks.length;
																		i++
																	) {
																		var task = formValues.tasks[i];

																		if (task.questions.length > 0) {
																			error = true;
																			break;
																		}
																		if (task.description) {
																			error = true;
																			break;
																		}
																		if (task.goal_screen_node_id) {
																			error = true;
																			break;
																		}
																	}
																	setFormErrors(form_errors);
																	if (error) {
																		setSwitchConfirmModal({
																			...switchConfirmModal,
																			open: true,
																			objective: "open",
																		});
																	} else {
																		setFormValues({
																			...formValues,
																			objective: "open",
																		});

																		savePrototypeTestData(
																			{
																				...formValues,
																				objective: "open",
																			},
																			false
																		);
																	}
																}}
																isChecked={
																	formValues.objective == "open" ? true : false
																}
																label="I want users to explore the prototype"
																sublabel="Let participants explore the prototype freely and share their feedback"
															/>
														</div>
													</div>
													<div className="create-test-preview-area">
														<Text type={"overline"} children={"Preview"} />
														<div className="create-test-preview-area-inner">
															<img
																src={
																	process.env.REACT_APP_URL +
																	"img/prototype-test.svg"
																}
																alt="img"
															/>
														</div>
														<GuideLink methodology={"prototype test"} />
													</div>
												</div>
												<div className="card-sorting-test-wrap prefer-design-wrap">
													<div className="cardsorting-wrap-mid-data">
														<div className="d-block">
															<div className="d-flex align-items-center lg-flex-column">
																<div className="d-flex align-items-center">
																	<Text
																		type={"body-text-2"}
																		fontWeight={"medium-font"}
																		cssClasses={"dark-text"}
																	>
																		Allow testers to participate on
																	</Text>
																</div>
															</div>
															<div
																className={`device-selection-radio justify-content-start d-flex mt-20`}
															>
																<RadioButton
																	name="test-device"
																	label="All devices"
																	id="allDevices"
																	value="all"
																	img={"desktop-and-phone"}
																	isChecked={
																		test.device === "all" ? true : false
																	}
																	onChange={(e) => {
																		updateTestDevice("all", {
																			formSnapshot: formValues,
																		});
																	}}
																/>
																<RadioButton
																	name="test-device"
																	label={"Mobile only"}
																	id="mobileOnly"
																	value="mobile"
																	img={"Phone"}
																	isChecked={
																		test.device === "mobile" ? true : false
																	}
																	onChange={() => {
																		if (
																			formValues.is_screen_recording_enabled ==
																			1
																		) {
																			setTestSettingModal({
																				...testSettingModal,
																				open: true,
																			});
																		} else {
																			updateTestDevice("mobile", {
																				formSnapshot: formValues,
																			});
																		}
																	}}
																/>

																<RadioButton
																	name="test-device"
																	label={"Desktop only"}
																	id="desktopOnly"
																	img={"Desktop"}
																	value="Mobile only"
																	isChecked={
																		test.device === "desktop" ? true : false
																	}
																	onChange={() => {
																		updateTestDevice("desktop", {
																			formSnapshot: formValues,
																		});
																	}}
																/>
															</div>
														</div>
													</div>
												</div>
												<div className="card-sorting-test-wrap prefer-design-wrap">
														<div className="cardsorting-wrap-mid-data">
															<div className="d-flex justify-content-between">
																<div className="d-flex align-items-center lg-flex-column">
																	<div className="d-flex align-items-center">
																		<Text
																			type={"subtitle-2"}
																			fontWeight={"medium-font"}
																		>
																			Screen Recording
																		</Text>
																		<Text
																			type={"overline"}
																			fontWeight={"medium-font"}
																			cssClasses={"ml-12"}
																		>
																			[BETA]
																		</Text>
																	</div>
																	<div className="d-flex align-items-center dual-icon">
																		<Tag
																			cssClasses={`d-flex align-items-center ml-12 ml-lg-00`}
																			title={
																				<>
																					<Icon
																						value={"desktop"}
																						size={"small"}
																						colorClass={"mr-1"}
																					/>{" "}
																					<span className="project-tag-name">
																						Desktop only
																					</span>
																				</>
																			}
																			type="white-tag"
																		/>
																		<Tag
																			cssClasses={`d-flex align-items-center ml-12`}
																			title={
																				<>
																					<Icon
																						value={"chrome"}
																						size={"small"}
																						cssClasses={"mr-1"}
																					/>{" "}
																					<span className="project-tag-name">
																						Chrome browser
																					</span>
																				</>
																			}
																			type="white-tag"
																		/>
																	</div>
																</div>
																<div className="d-flex justify-content-end align-items-start">
																	<Tag
																		title={"New"}
																		cssClasses={"m-0"}
																		type={"purple-200-tag"}
																	/>
																</div>
															</div>

															<Text
																type={"body-text-3"}
																fontWeight={"medium-font"}
																cssClasses={"mt-1"}
															>
																Record users' interactions with the screen.
															</Text>
															<div className="mt-24">
																<div
																	className={`recording-option d-flex align-items-center${isScreenRecordingUnavailable
																		? " not-available"
																		: ""
																		}`}
																>
																	<ToggleButton
																		key={`screen-recording-toggle-${screenRecordingToggleMountKey}`}
																		id="screen"
																		isChecked={
																			formValues.is_screen_recording_enabled ==
																			1
																		}
																		isDisabled={isScreenRecordingUnavailable}
																		onChange={() => {
																			if (isScreenRecordingUnavailable) {
																				return;
																			}
																			if (
																				formValues.is_screen_recording_enabled ==
																				1
																			) {
																				const newValue = 0;
																				setFormValues({
																					...formValues,
																					is_screen_recording_enabled: newValue,
																				});

																				savePrototypeTestData(
																					{
																						...formValues,
																						is_screen_recording_enabled: newValue,
																					},
																					false
																				);
																			} else {
																				setScreenRecordingEnableModalOpen(true);
																			}
																		}}
																	/>
																	<label
																		htmlFor="screen"
																		className={`d-flex align-items-center mb-0${isScreenRecordingUnavailable
																			? ""
																			: " cursor"
																			}`}
																	>
																		<Icon
																			size={"medium"}
																			value={"screen-recording"}
																			cssClasses={"ml-12"}
																			hover={
																				!isScreenRecordingUnavailable &&
																				formValues.is_screen_recording_enabled !==
																				1
																			}
																			colorClass={
																				isScreenRecordingUnavailable
																					? "gray-500-svg"
																					: formValues.is_screen_recording_enabled ==
																						1
																						? "gray-900-svg"
																						: ""
																			}
																		/>
																		<Text
																			type={"body-text-2"}
																			cssClasses={`ml-12 medium-font ${!isScreenRecordingUnavailable &&
																				formValues.is_screen_recording_enabled ==
																				1
																				? "dark-text"
																				: ""
																				}`}
																		>
																			Screen Recording
																		</Text>
																	</label>
																</div>
																<div className="recording-option d-flex align-items-center mt-24 not-available">
																	<ToggleButton
																		id="video"
																		isChecked={false}
																		isDisabled={true}
																	/>
																	<Icon
																		size={"medium"}
																		value={"video"}
																		cssClasses={"ml-12"}
																		colorClass={"gray-500-svg"}
																		hover={true}
																	/>
																	<Text
																		type={"body-text-2"}
																		cssClasses={"ml-12"}
																	>
																		Video Recording
																	</Text>
																	<Tag
																		title={"Coming soon"}
																		cssClasses={"ml-12"}
																		type={""}
																	/>
																</div>
																<div className="recording-option d-flex align-items-center mt-24 not-available">
																	<ToggleButton
																		id="audio"
																		isChecked={false}
																		isDisabled={true}
																	/>
																	<Icon
																		size={"medium"}
																		value={"audio"}
																		cssClasses={"ml-12"}
																		colorClass={"gray-500-svg"}
																		hover={true}
																	/>
																	<Text
																		type={"body-text-2"}
																		cssClasses={"ml-12"}
																	>
																		Audio Recording
																	</Text>
																	<Tag
																		title={"Coming soon"}
																		cssClasses={"ml-12"}
																		type={""}
																	/>
																</div>
															</div>

															{isScreenRecordingUnavailable && (
																<div className="mt-24">
																	<ToastMessage
																		icon={"desktop"}
																		colorClass={"secondary-purple-200-svg"}
																		type={"info"}
																		message={
																			<Text type={"body-text-2"}>
																				Screen recording is only available for
																				desktop users on Google Chrome. Switch to{" "}
																				<b>All devices</b> or <b>Desktop only</b>{" "}
																				to enable this feature.
																			</Text>
																		}
																		closable={false}
																	/>
																</div>
															)}
															{!isScreenRecordingUnavailable &&
																formValues.is_screen_recording_enabled == 1 && (
																<div className="mt-24">
																	<ToastMessage
																		icon={"desktop"}
																		colorClass={"secondary-purple-200-svg"}
																		type={"info"}
																		message={
																			<>
																				<Text type={"body-text-2"}>
																					Please note, only participants using
																					Google Chrome on their desktop will be
																					able to compete the test.
																				</Text>
																			</>
																		}
																		closable={false}
																	/>
																</div>
															)}
														</div>
													</div>

												{renderTasks()}
												{checkIfAddBtn() ? (
													<div>
														<Button
															type={"primary"}
															size={"large"}
															label="Add new task"
															iconLeft={
																<Icon
																	value="add"
																	colorClass={"gray-50-svg"}
																	size="small"
																/>
															}
															onClick={() => {
																if (formValues.tasks.length < 5) {
																	addPrototypeTestTask();
																} else {
																	showError(
																		"You cannot add more than 5 tasks."
																	);
																}
															}}
															microLoading={addTaskLoading}
															state={
																formValues.tasks.length < 5
																	? "active"
																	: "disabled"
															}
														/>
													</div>
												) : (
													<div>
														<Button
															type={"primary"}
															size={"large"}
															label="Add new task"
															iconLeft={
																<Icon
																	value="add"
																	colorClass={"gray-50-svg"}
																	size="snall"
																/>
															}
															state={"disabled"}
														/>
													</div>
												)}
											</Accordian>
											<Accordian
												title={"Conclusion questions"}
												subtitle={"(Optional)"}
												tooltip={"Some cool text"}
												open={accordians["conclusion"] ? true : false}
												onChange={() => {
													let new_accordians = Object.assign({}, accordians);

													for (var key in accordians) {
														if (key == "conclusion") {
															if (accordians[key]) {
																new_accordians[key] = false;
															} else {
																new_accordians[key] = true;
															}
														}
													}
													setAccordians(new_accordians);
												}}
												questionCount={concCount}
											>
												<ConclusionQuestions
													ref={conclusionRef}
													questions={conclusionQuestions}
													test={test}
													setLoading={(status) => setIsSaved(status)}
													changeCount={(newCount) => {
														setConcCount(newCount);
													}}
													updateQuestions={(questions) => {
														setConclusionQuestions([...questions]);
													}}
												/>
											</Accordian>
										</div>
										<div className="btns-wrap-bottom">
											<Button
												onClick={() => {
													navigate("/r/test/" + test_id + "/welcome");
												}}
												type={"ghost"}
												label={"Previous"}
												size={"large"}
												iconLeft={
													<Icon
														value="back-arrow"
														colorClass="gray-900-svg"
														size={"large"}
													/>
												}
											/>
											<Button
												id="r_create_step_2_build_next_btn"
												onClick={(e) => {
													saveBuildTestStep();
												}}
												iconRight={
													<Icon
														value="forward-arrow"
														colorClass="gray-50-svg"
													/>
												}
												label="Next"
												size={"large"}
												state={!checkValidBtnState() ? "active" : "disabled"}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="three-column-layout-right">
								<a
									onClick={(e) => {
										e.preventDefault();

										setShowSupportPanel(true);
									}}
									href={process.env.REACT_APP_URL + "r/support/contact"}
									target="_blank"
									className="support-button"
								>
									<Icon
										colorClass={"gray-50-svg"}
										value="support"
										size={"medium"}
									/>
									Support
								</a>
							</div>
						</>
					)}
				</div>
			</div>
			<ConfirmationModal
				confirm_message="Are you sure you want to delete this task?"
				confirm_btn_title="Delete"
				confirm_title="Delete Task"
				confirm_title_class={"text-danger"}
				openModal={confirmModal.open}
				close={() => {
					setConfirmModal({ ...confirmModal, open: false });
				}}
				confirm={() => {
					setConfirmModal({ ...confirmModal, open: false });

					deleteTask(confirmModal.task_id);
				}}
			/>

			<ConfirmationModal
				confirm_message={
					<>
						Switching the objective may result in changes in questions, goal
						screens and related settings.
						<div className="mt-3">
							Are you sure you want to change the objective of the prototype
							test?
						</div>
					</>
				}
				confirm_btn_title="Proceed"
				confirm_title="Some informations may be lost"
				confirm_title_class={"text-danger"}
				openModal={switchConfirmModal.open}
				close={() => {
					setSwitchConfirmModal({
						...switchConfirmModal,
						open: false,
					});
				}}
				confirm={() => {
					setSwitchConfirmModal({
						...switchConfirmModal,
						open: false,
					});

					setFormValues({
						...formValues,
						objective: switchConfirmModal.objective,
					});

					savePrototypeTestData(
						{
							...formValues,
							objective: switchConfirmModal.objective,
						},
						false
					);
				}}
			/>
			<ChangeOrderModal
				objective={formValues.objective}
				tasks={formValues.tasks}
				open={changeOrderModal.open}
				rtl={test.language == "ar" ? true : false}
				close={() => {
					setChangeOrderModal({ ...changeOrderModal, open: false });
				}}
				updateOrder={(tasks) => {
					setChangeOrderModal({ ...changeOrderModal, open: false });
					setFormValues({ ...formValues, tasks: tasks });
				}}
			/>
			<HelpModal
				open={helpModal.open}
				close={() => {
					setHelpModal({ ...helpModal, open: false });
				}}
				heading={"Figma prototype criteria"}
				body={
					<div className="prototype-criteria-modal-data">
						<Text
							type={"body-text-2"}
							fontWeight={"semi-bold-font"}
							cssClasses="purple-color"
						>
							File Access & Settings
						</Text>
						<ul>
							<li>
								<span>Eliminate password protection</span> from your Figma
								prototype.
							</li>
							<li>
								<span>Configure permissions</span> for your Figma file and
								prototype to enable viewing by anyone with the link. Otherwise,
								the preview of your prototype won't load, and testers won't be
								able to view it during the test. Please note that choosing
								"Anyone with a link [can view prototypes only]" will also result
								in an error since UserQ must have access to the file.
							</li>

							<li>
								<span>Create a designated testing file.</span> Duplicate your
								prototype and remove all irrelevant pages, frames, assets,
								images, and elements before importing to UserQ. We advise
								creating separate files for each flow that requires testing.
							</li>
						</ul>
						<Text
							type={"body-text-2"}
							fontWeight={"semi-bold-font"}
							cssClasses="purple-color"
						>
							Designs & Screens
						</Text>

						<ul>
							<li>
								<span>The number of screens</span> in your prototype to speed up
								the tester's experience. It is recommended to limit the frames
								and pages to only what is needed for testing.
							</li>

							<li>
								<span> Use separate top-level frames for each screen.</span>{" "}
								Components that are not within a frame will cause processing
								issues for UserQ.
							</li>

							<li>
								<span> Compress images</span> within the prototype before
								syncing. Large embedded photos may result in very large file
								sizes, which can be challenging to load.
							</li>

							<li>
								<span> Simplify custom fonts.</span> Custom fonts can increase
								the size of your Figma prototype, making it difficult to load
								for testers. Moreover, using a large number of custom fonts or
								large font files can negatively affect the loading times of your
								prototype. If using a custom icon font, consider converting the
								icons to outlines to reduce the use of custom fonts.
							</li>
						</ul>
						<Text
							type={"body-text-2"}
							fontWeight={"semi-bold-font"}
							cssClasses="purple-color"
						>
							Interactions
						</Text>
						<ul>
							<li>
								<span>Include at least two screens</span> in your Figma
								prototype and hotspots on the first screen linking to the
								second. Otherwise, you won't be able to import.
							</li>

							<li>
								<span>Verify</span> that all necessary screens for the test are
								correctly linked in Figma.
							</li>
						</ul>
					</div>
				}
			/>
			<ConfirmationModal
				openModal={testSettingModal.open}
				confirm_title="Switch device?"
				confirm_message={
					<>
						Switching to <b>mobile only</b> will disable the{" "}
						<b>screen recording feature</b>, as it is only available on desktop.
						Please review your settings before proceeding.
					</>
				}
				custom_confirm_message={true}
				confirm_btn_title={"Confirm"}
				cancel_btn_title={"Cancel"}
				close={() => {
					setTestSettingModal({
						...testSettingModal,
						open: false,
					});
				}}
				confirm={() => {
					updateTestDevice("mobile", { formSnapshot: formValues });
				}}
				confirm_btn_loading={deviceSettingLoading}
			/>
			<ConfirmationModal
				openModal={screenRecordingEnableModalOpen}
				confirm_title="Screen recording"
				confirm_message={
					<>
						<Text type={"body-text-2"} fontWeight={"medium-font"}>
							{SCREEN_RECORDING_DESKTOP_CHROME_COPY}
						</Text>
						{/* <Text type={"body-text-2"} cssClasses={"mt-16 gray-text"}>
							If you proceed, &quot;Allow testers to participate on&quot; will be
							set to Desktop only.
						</Text> */}
					</>
				}
				custom_confirm_message={true}
				confirm_btn_title={"Proceed"}
				cancel_btn_title={"Cancel"}
				close={() => {
					setScreenRecordingEnableModalOpen(false);
					setScreenRecordingProceedLoading(false);
					setScreenRecordingToggleMountKey((k) => k + 1);
				}}
				confirm={confirmEnableScreenRecording}
				confirm_btn_loading={screenRecordingProceedLoading}
			/>
		</LayoutResearcher>
	);
}
